module.exports = __webpack_public_path__ + "assets/img/material_empty.1c24aa7f.png";